// src/components/BotMessage.jsx
import React from 'react';
import { Box, Avatar, Typography, Card, CardContent } from '@mui/material';

export function MealMessage() {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 1 , maxWidth: 320}}>
      <Avatar
        alt="전적이"
        src="/profile.webp"
        sx={{ width: 40, height: 40 }}
      />

      <Box sx={{ ml: 2,maxHeight:300 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.7 }}>
          <Typography variant="body1" sx={{ color: '#fff', fontWeight: 'bold' }}>
            전적이
          </Typography>
          <Box
            sx={{
              backgroundColor: '#3E70ED',
              color: 'white',
              borderRadius: '5px',
              px: '4px',
              py: '2px',
              fontSize: '0.75rem',
              fontWeight: 'bold'
            }}
          >
            ✓앱
          </Box>
          <Typography variant="body2" sx={{ color: '#72767d', fontSize: '0.8rem' }}>오전 08:37</Typography>
        </Box>

        {/* ✅ 비율 유지 줄어들기용 박스 */}
        <Box
          sx={{
            width: '100%',
            maxWidth: 400,
            transform: 'scale(0.9)',
            transformOrigin: 'top left',
          }}
        >
          <Card
            sx={{
              backgroundColor: '#242429',
              border: '2px solid #323237',
              borderLeft: '5px solid #686662',
              color: 'white',
              borderRadius: '5px',
              width: '100%',
            }}
          >
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.4 }}>
                <Avatar
                  alt="임베드 아이콘"
                  src="/TichipIcon.webp"
                  sx={{ width: 24, height: 24 }}
                />
                <Typography variant="h6" sx={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                  티칩의 급식정보
                </Typography>
              </Box>
              <Typography
                variant="body2"
                sx={{ opacity: 1, mb: 1, whiteSpace: 'pre-line', wordBreak: 'keep-all' }}
              >
                혼합잡곡밥{"\n"}몽글순두부들깨탕{"\n"}실파콩나물무침{"\n"}건파래자반{"\n"}배추김치{"\n"}아이스크림{"\n"}닭볶음탕
              </Typography>
              <Typography variant="body2" sx={{ opacity: 1, fontSize: '0.8rem' }}>
                2025년 04월 01일 점심 급식정보
              </Typography>
            </CardContent>
          </Card>
        </Box>
      </Box>
    </Box>
  );
}

export function OverMessage() {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 0, maxWidth: 370}}>
      {/* 왼쪽 봇 프로필 */}
      <Avatar alt="전적이" src="/profile.webp" sx={{ width: 40, height: 40 }} />

      {/* 오른쪽 전체 메시지 */}
      <Box sx={{ ml: 2 , maxWidth: 200, maxHeight:30}}>
        {/* 봇 이름 + 앱 라벨 + 시간 */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.7 }}>
          <Typography sx={{ color: '#fff', fontWeight: 'bold' }}>전적이</Typography>
          <Box
            sx={{
              backgroundColor: '#3E70ED',
              color: 'white',
              borderRadius: '4px',
              px: '4px',
              py: '2px',
              fontSize: '0.75rem',
              fontWeight: 'bold'
            }}
          >
            ✓앱
          </Box>
          <Typography variant="body2" sx={{ color: '#72767d', fontSize: '0.8rem'}}>오후 6:54</Typography>
        </Box>

        {/* 전체 임베드 카드에 스케일 적용 */}
        <Box
          sx={{
            display: 'inline-block',
            transform: 'scale(0.85)',            // 크기 비율 조정
            transformOrigin: 'top left',
            whiteSpace: 'nowrap',
            lineHeight: 0,
            overflow: 'hidden',
            mt: 0.5
          }}
        >
          <Card
            sx={{
              backgroundColor: '#242429',
              border: '2px solid #323237',
              borderLeft: '5px solid #686662',
              color: 'white',
              borderRadius: '5px',
              maxWidth: 420
            }}
          >
            <CardContent>
              {/* 상단: 제목 + 마녀 아이콘 */}
              <Box sx={{ display: 'flex', justifyContent: 'space-between'}}>
                <Box>
                  <Typography sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>티칩#3577의 정보</Typography>
                  <Box sx={{ mt: 1, display: 'flex', gap: 8 }}>
                    <Box>
                      <Typography sx={{ fontSize: '0.9rem' }}>추천레벨</Typography>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Box component="img" src="/5.png" alt="" sx={{ width: 24, height: 24 }} />
                      </Box>
                    </Box>
                    <Box>
                      <Typography sx={{ fontSize: '0.9rem' }}>자경티어</Typography>
                      <Typography sx={{ fontSize: '0.9rem' }}>티어 없음</Typography>
                    </Box>
                  </Box>
                </Box>

                <Box>
                  <Avatar
                    src="/OWIcon.png"
                    alt="마녀 아이콘"
                    sx={{ width: 80, height: 80, borderRadius: '6px' }}
                  />
                </Box>
              </Box>

              {/* 티어 줄 */}
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  mt: 2,
                  gap: 3
                }}
              >
                {/* 탱커 */}
                <Box sx={{ textAlign: 'center' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <Box component="img" src="/tank.png" alt="" sx={{ width: 18, height: 18 }} />
                    <Typography sx={{ fontSize: '0.9rem' }}>탱커티어</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                    <Box component="img" src="/Master.png" alt="마스터 아이콘" sx={{ width: 16, height: 16 }} />
                    <Typography sx={{ fontSize: '0.9rem' }}>마스터3</Typography>
                  </Box>
                </Box>

                {/* 딜러 */}
                <Box sx={{ textAlign: 'center' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <Box component="img" src="/offense.png" alt="" sx={{ width: 18, height: 18 }} />
                    <Typography sx={{ fontSize: '0.9rem' }}>딜러티어</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                    <Box component="img" src="/Master.png" alt="마스터 아이콘" sx={{ width: 16, height: 16 }} />
                    <Typography sx={{ fontSize: '0.9rem' }}>마스터4</Typography>
                  </Box>
                </Box>

                {/* 힐러 */}
                <Box sx={{ textAlign: 'center' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <Box component="img" src="/support.png" alt="" sx={{ width: 18, height: 18 }} />
                    <Typography sx={{ fontSize: '0.9rem' }}>힐러티어</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                    <Box component="img" src="/Platinum.png" alt="플래티넘 아이콘" sx={{ width: 16, height: 16 }} />
                    <Typography sx={{ fontSize: '0.9rem' }}>플래티넘3</Typography>
                  </Box>
                </Box>
              </Box>

              {/* 하단 배경 이미지 */}
              <Box
                component="img"
                src="/OW-bg.png"
                alt="배경"
                sx={{
                  width: '100%',
                  height: 'auto',
                  borderRadius: '6px',
                  mt: 2
                }}
              />
            </CardContent>
          </Card>
        </Box>
      </Box>
    </Box>
  );
}